module.exports = __webpack_public_path__ + "5b3315d43defc7ce6c8f0113f35b264e.jpg";